import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/packages")({
  beforeLoad: () => {
    throw redirect({ to: "/pricing", replace: true, statusCode: 301 });
  },
});
